<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Add new key</h6>
            </div>
            <div class="card-body">
                <div v-if="saveMessage !== ''" class="alert alert-primary alert-dismissible fade show" role="alert">
                    {{saveMessage}}
                    <button @click="clearSaveMessage" type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div id="form">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-lg">Key</span>
                        </div>
                        <input class="form-control" v-model="key" type="text">
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-lg">Language</span>
                        </div>
                        <select v-model="languageCode" class="custom-select">
                            <option value="ALL">All languages</option>
                            <option v-for="(language, index) in systemLanguages" :key="index" :value="language.title">{{language.longTitle}}</option>
                        </select>
                    </div>
                    <button v-if="key !== ''" @click="addKey" class="btn btn-primary">Add</button>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
     data () {
        return {
            key: '',
            languageCode: 'ALL',
            saveMessage: ''
        }
    },
    methods : {
        addKey : function(){
            let self = this
            this.$http.post('/api/languages/add-translation', this.addParameters)
            .then(response => {
                this.$router.push(`/admin/translation-keys`)
                self.saveMessage = 'Key added successfully!'
            })
            .catch(error => {
                self.saveMessage = 'There was a problem adding the new key'
            })
        },
        formatKey : function(value){
            //SCREAMING_SNAKE_CASE formatting
            this.key = value.toUpperCase().replace('-', '_').replace(' ','_').replace(/[^_\dA-Z]/, '')
        },
        clearSaveMessage: function(){
            this.saveMessage = ''
        }
    },
    computed : {
        systemLanguages: function(){
            return this.$store.getters.systemLanguages
        },
        addParameters: function(key, languageCode){
            if(languageCode === 'ALL'){
                return {
                    key: this.key
                }
            }
            else{
                return {
                    key: this.key,
                    languageCode: this.languageCode
                }
            }
        }
    },
    mounted : function(){
    },
    watch: {
        key: function(value){
            this.formatKey(value)
        }
    }
}
</script>

<style lang="scss" scoped>
    div{
    span.input-group-text {
        width: 100px;
        }
    }
</style>

